<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="tab-item-ctn">
            <div class="search-ctn">
                <div class="search-ctn-right">
                    <div class="search-name">仓库</div>
                    <el-select
                        class="search-item"
                        size="small"
                        v-model="searchData.WarehouseId"
                        filterable
                        clearable
                        placeholder="请选择"
                        @visible-change="warehouseVisibleChange($event)"
                    >
                        <el-option v-for="optionItem in WarehouseList" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId" v-bind:key="optionItem.index"
                            ><span style="float: left">{{ optionItem.WarehouseName }}</span>
                            <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                        </el-option>
                    </el-select>
                    <div class="search-name">收款方式</div>
                    <el-select class="search-item" size="small" v-model="searchData.PayType">
                        <el-option label="全部" value></el-option>
                        <el-option v-for="item in payWayList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                    </el-select>
                    <div class="search-name">提交时间</div>
                    <el-date-picker
                        v-model="dateTimes"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                        @change="handleChange"
                        size="small"
                        class="search-name"
                    ></el-date-picker>
                    <div class="search-name">确认时间</div>
                    <el-date-picker
                        v-model="dateTimes2"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                        @change="handleChange2"
                        size="small"
                        class="search-name"
                    ></el-date-picker>
                    <div class="search-name">
                        <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="getTableData">查询</el-button>
                        <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                    </div>
                </div>
            </div>
            <div class="table-ctn">
                <el-table
                    :header-cell-style="{ background: '#F2F6FC' }"
                    :data="tableSaleData"
                    border
                    style="width: 100%"
                    :default-sort="{ prop: 'PayAmount', order: 'descending' }"
                    :summary-method="getSummaries"
                    show-summary
                >
                    <el-table-column show-overflow-tooltip width="80px" type="index" sortable label="排名"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100px" prop="WareHouseName" label="出仓仓库"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100px" prop="PayTypeName" label="收款方式"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100px" prop="SaleTotal" sortable label="销售总额"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100px" prop="SaleCount" sortable label="销售单数"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100px" prop="DiscountAmount" sortable label="优惠金额" ></el-table-column>
                    <el-table-column show-overflow-tooltip sortable min-width="100" prop="SaleReturnTotal" label="退货总额"></el-table-column>
                    <el-table-column show-overflow-tooltip sortable min-width="100" prop="SaleReturnCount" label="退货单数"></el-table-column>
                    <el-table-column show-overflow-tooltip sortable min-width="100" :render-header="renderHeader" prop="OrderSaleAmount" label="实际销售额"></el-table-column>
                    <el-table-column show-overflow-tooltip sortable min-width="100" prop="ReducedRevenueAmount" label="减收金额"></el-table-column>
                    <el-table-column show-overflow-tooltip sortable min-width="100" prop="CostTotal" label="成本总额"></el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
export default {
    mixins: [mixin],
    name: '',
    components: {
        breadcrumb
    },
    data() {
        return {
            dateTimes: [],
            dateTimes2: [],
            searchData: {
                WarehouseId: '',
                CStartDate: '',
                CEndDate: '',
                StartDate: '',
                EndDate: '',
                PayType: '',
                SortProp: '',
                SortType: ''
            },
            payWayList: [],
            tableSaleData: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            WarehouseList:[]
        };
    },
    created() {
        //当前设定的日期时间
        let d = new Date();
        let year1, month1, day1;
        [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
        let date1 = new Date(year1, month1, day1, 0);
        this.dateTimes.push(date1);
        //前一天设定的日期时间
        let year2, month2, day2;
        d.setTime(d.getTime());
        [year2, month2, day2] = [d.getFullYear(), d.getMonth(), 1];
        let date2 = new Date(year2, month2, day2, 0);
        this.dateTimes.unshift(date2);

        this.searchData.CStartDate = date2;
        this.searchData.CEndDate = date1;
    },
    mounted() {
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.getTableData();
        this.getPay();
    },
    methods: {
        renderHeader(h, { column }) {
            const orderSaleAmount = h(
                'div',
                {
                    slot: 'content'
                },
                '实际销售额=销售总额-退货总额，不包括优惠及运费'
            );
            return h('span', [
                h(
                    'el-tooltip',
                    {
                        props: {
                            placement: 'top'
                        }
                    },
                    [
                        column.property == 'OrderSaleAmount' ? orderSaleAmount : '',
                        h('i', {
                            class: 'el-icon-warning-outline',
                            style: 'color:orange;margin-right:5px;'
                        })
                    ]
                ),
                h('span', column.label)
            ]);
        },
        getWarehouse() {
            this.$util.getWarehouse(1).then(data => {
                this.WarehouseList = data;
            });
        },
        warehouseVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.WarehouseList.length <= 1) that.getWarehouse();
            }
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    if (index === 3 || index === 6 || index > 7) sums[index] = sums[index].toFixed(2) + ' 元';
                    else sums[index] = sums[index] + '';
                } else {
                    sums[index] = '';
                }
            });

            return sums;
        },
        // 重置表单
        resetSearch() {
            this.searchData.WarehouseId = '';
            this.searchData.StartDate = '';
            this.searchData.EndDate = '';
            this.searchData.CStartDate = '';
            this.searchData.CEndDate = '';
            this.searchData.PayType = '';
            this.SortProp = '';
            this.SortType = '';
            this.dateTimes =[];
            this.dateTimes2 =[];

        },
        // 获取数据
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/DataStatistics/SalePayTypeStatistics_V2',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    this.tableSaleData = data;
                })
                .catch(() => {});
        },
        handleChange(val) {
            if (val) {
                this.searchData.CStartDate = val[0];
                this.searchData.CEndDate = val[1];
            } else {
                this.searchData.CStartDate = '';
                this.searchData.CEndDate = '';
            }
        },
        handleChange2(val) {
            if (val) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        //  结算方式
        getPay() {
            this.$util.getPay().then(data => {
                this.payWayList = data;
            });
        }
    }
};
</script>
